import {BaseData} from '../base/static_config_data/BaseData';
import {ArrayWrap} from '../base/static_config_data/ArrayWrap';
import {CardData, ICardData} from './card_stack_data/CardData';
import {ActiveData} from '../../ActiveData';
import {PlayerDataEvent} from './player_data/PlayerDataEvent';

export class PlayerData extends BaseData
{
    cards!: ArrayWrap<CardData, ICardData>;

    constructor(public config: IPlayerData | null = null) {
        super();

        if (!this.config) {
            return;
        }

        if (!this.config.cards) {
            this.config.cards = [];
        }

        this.cards = new ArrayWrap<CardData, ICardData>(CardData, this.config.cards);
    }

    get cardsCount(): number {
        return this.config!.cardsCount;
    }

    set cardsCount(value: number) {
        this.config!.cardsCount = value;
        ActiveData.addEventToPool<number>(this, PlayerDataEvent.CARDS_COUNT_CHANGED, this.config!.cardsCount);
    }

    get visible(): boolean {
        return this.config!.visible;
    }

    set visible(value: boolean) {
        this.config!.visible = value;
        ActiveData.addEventToPool<boolean>(this, PlayerDataEvent.VISIBLE_CHANGED, this.config!.visible);
    }

    get id(): string {
        return this.config!.id;
    }
}

export interface IPlayerData
{
    cards: ICardData[];
    cardsCount: number;
    id: string;
    visible: boolean;
}
